import * as v from "valibot";
import { rpcContract } from "../rpc";

export const deleteEmailCustomizationRpcContract = rpcContract({
  name: "delete-email-customization",
  paramsSchema: v.object({
    linkId: v.pipe(v.string("linkId must be a string"), v.uuid("Invalid linkId: must be a valid UUID")),
    influencerId: v.pipe(
      v.string("influencerId must be a string"),
      v.uuid("Invalid influencerId: must be a valid UUID (e.g., 123e4567-e89b-12d3-a456-426614174000)"),
    ),
  }),
  resultSchema: v.undefined(),
});

export type DeleteEmailCustomizationParams = v.InferOutput<
  (typeof deleteEmailCustomizationRpcContract)["paramsSchema"]
>;
export type DeleteEmailCustomizationResult = v.InferOutput<
  (typeof deleteEmailCustomizationRpcContract)["resultSchema"]
>;
